import { render, staticRenderFns } from "./ShowcaseProducts.vue?vue&type=template&id=2fc5c7c4&"
import script from "./ShowcaseProducts.vue?vue&type=script&lang=js&"
export * from "./ShowcaseProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports